const ProviderConstants = (function () {
  const providerCodes = {
    HUBSPOT: 'hubspot',
  };

  return { providerCodes };
})();

export default ProviderConstants;
